import { FC, useMemo } from 'react';
import SettingsContext from '@/contexts/settings';
import useSettings from '@/hooks/useSettings';

const Settings: FC = ({ children }) => {
  const { schoolName, schoolTel, schoolMail, schoolAddress, businessHour, transferTicketTiming } = useSettings();

  // 営業時間
  const businessHours = useMemo(() => {
    const start = Number(businessHour.open.hour);
    const end = Number(businessHour.close.hour);
    const range = end - start + 1;

    return [...Array.from(Array(range).keys())].map((hour) => {
      return hour + start < 10 ? '0' + (hour + start) : hour + start;
    });
  }, [businessHour.close.hour, businessHour.open.hour]);

  return (
    <SettingsContext.Provider
      value={{
        schoolName,
        schoolTel,
        schoolMail,
        schoolAddress,
        businessHour,
        businessHours,
        transferTicketTiming,
      }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default Settings;
